import { type CompetitionCollectionAvailabilityItem, type DynamicCriteriaType } from '@app/client';

export const getCriteriaTooltipCopy = (collectionCriteria: CompetitionCollectionAvailabilityItem, translate) => {
    const formatCriteria = (criteria: DynamicCriteriaType) =>
        criteria?.reduce<{ key: string; value: number }[]>((acc, item) => {
            const key = Object.keys(item)[0];
            const value = (item[key].amount as number) || (item[key].percent as number);
            return [...acc, { value, key }];
        }, []);

    const tooltipCopy = {
        MinimumAssetCount: (tokenCount) => translate('list_item_error_minimum_asset_count', { tokenCount }),
        AptosMinimumAssetCount: (tokenCount) => translate('list_item_error_minimum_asset_count', { tokenCount }),
        PloygonMinimumAssetCount: (tokenCount) => translate('list_item_error_minimum_asset_count', { tokenCount }),
        MinimumAssetsOnSalePercentage: (assetForSalePercent) =>
            translate('list_item_error_minimum_asset_on_sale', { assetForSalePercent }),
        AptosMinimumAssetsOnSalePercentage: (assetForSalePercent) =>
            translate('list_item_error_minimum_asset_on_sale', { assetForSalePercent }),
        PolygonMinimumAssetsOnSalePercentage: (assetForSalePercent) =>
            translate('list_item_error_minimum_asset_on_sale', { assetForSalePercent }),
        MinimumUniqueCollectionOwnerPercentage: (ownersRatio) =>
            translate('list_item_error_minimum_owners_percent', { ownersRatio }),
        AptosMinimumUniqueCollectionOwnerPercentage: (ownersRatio) =>
            translate('list_item_error_minimum_owners_percent', { ownersRatio }),
        PolygonMinimumUniqueCollectionOwnerPercentage: (ownersRatio) =>
            translate('list_item_error_minimum_owners_percent', { ownersRatio }),
        MinimumSalesCount: (sales) => translate('list_item_error_minimum_sales', { sales }),
        AptosMinimumSalesCount: (sales) => translate('list_item_error_minimum_sales', { sales }),
        PolygonMinimumSalesCount: (sales) => translate('list_item_error_minimum_sales', { sales }),
    };
    const currentState = formatCriteria(collectionCriteria.current_state);
    const evaluatedCriteria = formatCriteria(collectionCriteria.evaluated_criteria);
    const criteriaNotMatched =
        !collectionCriteria?.is_valid &&
        evaluatedCriteria.find((criteria) => {
            const currentStateValue = currentState.find((item) => item.key == criteria.key)?.value || 0;
            return currentStateValue < criteria.value;
        });

    return criteriaNotMatched ? tooltipCopy[criteriaNotMatched.key]?.(criteriaNotMatched.value) : '';
};
